/* ============================================================
   CRO media — quality-video playback + review photo lightbox
   ------------------------------------------------------------
   Two small, independent enhancements. Both degrade gracefully:
   the video autoplays from its HTML attributes with no JS at all,
   and review photos are plain <img>s inside buttons.

     1. Quality video (sections/cro-product-video.liquid)
        Pauses the loop while it is off-screen so a 15s clip isn't
        burning battery/data below the fold, and honours
        prefers-reduced-motion by leaving it paused on its poster
        with controls exposed.

     2. Review photos (sections/cro-reviews.liquid)
        Click-to-enlarge overlay. Bound once by delegation on
        `document`, which survives InstantClick's body swap.
   ============================================================ */
(function () {
  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- 1. quality video ---------------- */

  function initVideos() {
    var wraps = document.querySelectorAll('[data-cro-qvideo]');

    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.dataset.croVideoBound) return;
      wrap.dataset.croVideoBound = '1';

      var video = wrap.querySelector('video');
      if (!video) return;

      if (REDUCED) {
        video.removeAttribute('autoplay');
        video.setAttribute('controls', '');
        video.pause();
        return;
      }

      if (!('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // play() rejects when the browser blocks autoplay — ignore,
              // the poster stays up and controls remain available.
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );

      io.observe(video);
    });
  }

  /* ---------------- 2. review photo lightbox ---------------- */

  var overlay;

  function buildOverlay() {
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'cro-lightbox';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<button type="button" class="cro-lightbox__close" aria-label="Close">&times;</button>' +
      '<img class="cro-lightbox__img" alt="">';

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('cro-lightbox__close')) {
        closeOverlay();
      }
    });

    document.body.appendChild(overlay);
    return overlay;
  }

  var lastTrigger = null;

  function openOverlay(src, alt, trigger) {
    var el = buildOverlay();
    var img = el.querySelector('.cro-lightbox__img');
    img.setAttribute('src', src);
    img.setAttribute('alt', alt || '');
    el.removeAttribute('hidden');
    document.documentElement.classList.add('cro-lightbox-open');
    lastTrigger = trigger || null;
    el.querySelector('.cro-lightbox__close').focus();
  }

  function closeOverlay() {
    if (!overlay || overlay.hasAttribute('hidden')) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('cro-lightbox-open');
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function bindLightbox() {
    if (window.__croLightboxBound) return;
    window.__croLightboxBound = true;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-cro-lightbox]');
      if (!trigger) return;
      var full = trigger.getAttribute('data-full');
      if (!full) return;
      e.preventDefault();
      var img = trigger.querySelector('img');
      openOverlay(full, img ? img.getAttribute('alt') : '', trigger);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeOverlay();
    });
  }

  /* ---------------- boot ---------------- */

  function init() {
    initVideos();
    bindLightbox();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
